import React, { useEffect, useState } from 'react';
import { BackendLink, HeaderOfPages, MiniContainer } from '../../Components';
import {SmartTrainingCard} from '../../Components';
import headerImg from '../../Assets/Images/training.jpg';
import './TrainingPage.css';

const TrainingPage = () => {
    const [trainings, setTrainings] = useState([]);
    const [loading, setLoading] = useState(true);
    const [service, setService] = useState({
        bgImg: headerImg,
        txt: 'Training Services'
    });

    useEffect(() => {
        const fetchTrainings = async () => {
            try {
                const response = await fetch(`${BackendLink}/AllTrianings/`); // bakr db
                // const response = await fetch(`${BackendLink}/AllTrainings/`);
                if (!response.ok) throw new Error("Failed to fetch trainings");
                const data = await response.json();
                setTrainings(data);
            } catch (err) {
                console.error('Error fetching trainings:', err);
            } finally {
                setLoading(false);
            }
        };

        const fetchService = async () => {
            try {
                const response = await fetch(`${BackendLink}/AllServices/`);
                if (!response.ok) throw new Error("Failed to fetch services");
                const data = await response.json();
                const trainingService = data.find(item => item.txt === "Training Services");
                if (trainingService) {
                    const fullImgPath = trainingService.bgImg?.startsWith("http")
                        ? trainingService.bgImg
                        : `${BackendLink}${trainingService.bgImg}`;

                    setService({
                        bgImg: fullImgPath || headerImg,
                        txt: trainingService.txt || 'Training Services'
                    });
                }
            } catch (err) {
                console.error('Error fetching service data:', err);
                setService({
                    bgImg: headerImg,
                    txt: 'Training Services'
                });
            }
        };


        fetchTrainings();
        fetchService();
    }, []);

    return (
        <div className='training-page'>
            <HeaderOfPages
                contImg={service.bgImg}
                altImg={service.txt}
                title={service.txt}
            />
            <MiniContainer>
                <div className="training-section">
                    <ul className="allTraining">
                        {loading
                            ? Array.from({ length: 6 }).map((_, index) => (
                                <SmartTrainingCard key={index} loading={true} delay={index} />
                            ))
                            : trainings.length > 0
                                ? trainings.map((training, index) => (
                                    <SmartTrainingCard
                                        key={training.id}
                                        training={training}
                                        delay={index}
                                    />
                                ))
                                : Array.from({ length: 6 }).map((_, index) => (
                                    <SmartTrainingCard key={index} error={true} delay={index} />
                                ))
                        }
                    </ul>
                </div>
            </MiniContainer>
        </div>
    );
};

export default TrainingPage;
